export interface ArchieMockMessage {
  role: "user" | "assistant";
  content: string;
  actions?: { label: string; icon: string }[];
}

export const MOCK_ARCHIE_MESSAGES: ArchieMockMessage[] = [
  {
    role: "assistant",
    content: "Hi! I can see you're searching <strong>Toronto HQ interactions from the last 7 days</strong>. I found 2,847 results. What would you like to know?",
  },
  {
    role: "user",
    content: "Show me any calls where customers mentioned cancellation",
  },
  {
    role: "assistant",
    content: "I found <strong>47 interactions</strong> mentioning cancellation:<br><br>• <strong>23</strong> successfully retained<br>• <strong>18</strong> resulted in cancellation<br>• <strong>6</strong> escalated to supervisor<br><br>Average handle time: <strong>12m 34s</strong> (2x your overall avg).",
    actions: [
      { label: "View results", icon: "search" },
      { label: "Export", icon: "download" },
    ],
  },
  {
    role: "user",
    content: "Which agents have the best retention rate?",
  },
  {
    role: "assistant",
    content: "Based on cancellation calls:<br><br>1. <strong>David Park</strong> — 87% retention (13/15)<br>2. <strong>Sarah Mitchell</strong> — 78% (7/9)<br>3. <strong>Emma Tremblay</strong> — 71% (5/7)<br><br>David spends +4 min avg on empathy and alternatives.",
    actions: [
      { label: "Add to dashboard", icon: "dashboard" },
    ],
  },
];

export const MOCK_COMMAND_SUGGESTIONS = [
  { text: "Find calls where customers mentioned cancellation this week", subtitle: "Natural language search powered by Archie" },
  { text: "Summarize yesterday's call volume by site", subtitle: "Archie can aggregate and explain trends" },
  { text: "Create a dashboard widget for agent retention rates", subtitle: "Archie can build widgets for you" },
];
